<template>
  <div>กรุณากรอกข้อมูล <b>กำไรเป้าหมาย</b></div>
</template>

<script>
export default {
  name: "notification-template",
};
</script>
